/**
 * Handle hamburger issues
 * @module handleHamburgers
 */

import $ from 'jquery';
import registerJQueryPlugin from '../lib/register-jquery-plugin';
import mergeOptions from '../lib/merge-options';
import Keyboard from './keyboard';

// Expose the function as a jQuery plugin for ease of use
export const PLUGIN_NAME = 'hamburger';
export const DEFAULTS = {
  switchClass: '',
  switchTarget: '',
};
/**
 * Applies any sort of event handlers for the switchClass.
 * @param  {jQuery} $el - link
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
const setEventListeners = ($el, options = {}) => {
  const $pageContent = $('#page-content');
  const $footerContent = $('#site-footer');
  const MOBILE_NAV_TRIGGER = $('#js-nav-side-mobile');
  const MOBILE_NAV_SIDEBAR = $('#js-nav-side');
  const MOBILE_NAV_CLOSE = $('#js-nav-side__close');
  let $changingElClass = $($el.attr('href'));
  // If a data-switch-target attribute was used instead of href
  if (options.switchTarget !== '') {
    $changingElClass = $(options.switchTarget);
  }
  $el.on('click', (evt) => {
    evt.preventDefault();
    const pageScrollPos = window.scrollY;
    if ($changingElClass.hasClass(options.switchClass)) {
      $changingElClass.removeClass(options.switchClass);
      $pageContent.css({ transform: '' });
      $footerContent.css({ transform: '' });
      window.scrollTo(0, $pageContent.data('scrollPos'));
      Keyboard.releaseFocus(MOBILE_NAV_SIDEBAR, MOBILE_NAV_TRIGGER);
      MOBILE_NAV_SIDEBAR.parent('div[role="dialog"]').attr('aria-modal', false);
    } else {
      $changingElClass.addClass(options.switchClass);
      $pageContent.css({ transform: `translateY(-${pageScrollPos}px)` }).data('scrollPos', pageScrollPos);
      $footerContent.css({ transform: `translateY(-${pageScrollPos}px)` });
      Keyboard.trapFocus(MOBILE_NAV_SIDEBAR);
      MOBILE_NAV_CLOSE.trigger('focus');
      MOBILE_NAV_SIDEBAR.parent('div[role="dialog"]').attr('aria-modal', true);
    }
  });
};
/**
 * Initializes switchClass.
 * @param {HTMLElement} el - link
 * @param {Object} options - Options used for wiring up the modal
 * @see DEFAULTS
 */
export default function hamburger(el, options = {}) {
  const $el = $(el);
  const opts = mergeOptions(DEFAULTS, options, $el);
  setEventListeners($el, opts);
}
registerJQueryPlugin(PLUGIN_NAME, hamburger);



// WEBPACK FOOTER //
// ./styleguide/src/assets/modules/hamburger.js